<template>
<div class="chapter">
<div class="inner_page">
<p class="image" id="fm01"><a id="page_xi"></a><img alt="Images" src="images/bulp.jpg"/></p>
<p class="hang">Verdigris (Ver-di-gree) <em>n.</em> a blue-green rust that tarnishes aging and forgotten copper coins, altering them entirely . . .<a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?69daa26c